// MemberLogin.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function MemberLogin() {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();
    
    // This should be replaced with proper API authentication
    // For now, redirect to proper member selection
    setError('Please use the main login system to access your vault.');
    setTimeout(() => {
      navigate('/member-selection');
    }, 2000);
  };

  return (
    <div className="member-login-bg">
      <form className="member-login-form" onSubmit={handleLogin}>
        <h2>Enter Your Family Code</h2>
        <input
          type="password"
          value={code}
          onChange={e => setCode(e.target.value)}
          placeholder="Enter code"
          className="member-login-input"
          disabled
        />
        {error && <div className="member-login-error">{error}</div>}
        <button type="submit" className="member-login-btn" disabled>Enter Vault</button>
      </form>
    </div>
  );
}
